export const handPhone = require("./welcome1.png");
export const helmetScroll = require("./welcome2.png");
export const envelope = require("./welcome3.png");
export const lock = require("./welcome4.png");
export const hotlineLock = require("../hotlineLock.png");
